import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getPriorToTypesAction } from 'store/underwriting/actions';
import { selectPriorToTypes } from 'store/underwriting/selectors';

import ConditionReviewItem from './ConditionReviewItem';
import { CONDITION_REVIEW_VARIANT, ConditionReviewTestIds } from './ConditionReviewList.constants';
import { listStyles } from './ConditionReviewList.styles';

const ConditionReviewList = ({
  conditions,
  review,
  variant = CONDITION_REVIEW_VARIANT.PROCESS,
}) => {
  const dispatch = useDispatch();
  const hasPriorToTypesLoaded = useSelector(selectPriorToTypes).length > 0;

  useEffectSafeStrictMode(() => {
    if (!hasPriorToTypesLoaded) {
      dispatch(getPriorToTypesAction());
    }
  }, [dispatch, hasPriorToTypesLoaded]);

  return (
    <Box data-testid={ConditionReviewTestIds.LIST} sx={listStyles}>
      {conditions.map(condition => (
        <ConditionReviewItem
          condition={condition}
          key={condition.key}
          review={review}
          variant={variant}
        />
      ))}
    </Box>
  );
};

ConditionReviewList.propTypes = {
  conditions: PropTypes.arrayOf(PropTypes.object).isRequired,
  review: PropTypes.object.isRequired,
  variant: PropTypes.string,
};

export default memo(ConditionReviewList);
